import {isLocalProfile} from '@web/core/config'
import {createStore} from '@web/helpers/redux'
import {browserConfirm, browserEventEmitter} from '@web/middlewares/browserEventEmitter'
import {uiEventAction} from '@web/middlewares/uiLogging'

import {FDSBridgeRootState as State} from '../../interfaces'

import {auth, orderInterruptedMiddleware, uiLogTracker} from './middleware'
import createRootReducer from './reducer'

const middlewares = [auth, orderInterruptedMiddleware, uiLogTracker, browserEventEmitter]

const store = createStore<State>({
    rootReducerCreator: createRootReducer,
    middlewares: [...middlewares],
    defaultMiddlewareOptions: {
        serializableCheck: {
            ignoredActions: [uiEventAction.type, browserConfirm.type],
        },
    },
})

export default store

if (isLocalProfile && module.hot) {
    module.hot.accept('./reducer', () => store.replaceReducer(createRootReducer()))
}
